import React from "react";
import AddIcon from "@material-ui/icons/Add";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { CBSearchField } from "../../../../../../features/forms/fields/cb-search-field/cb-search-field.component";
import { FileUploadWidget } from "../../../../../../features/file-attachments/file-upload-widget/file-upload-widget.component";

import { CbTemplateViewProps } from "../../../../types/cb-template-view/cb-template-view.props";
import { createCbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control-props.functions";

import { CbTemplateControlExPlansDueAt } from "../../../cb-template-control/components/cb-template-control-ex-plans-due-at/cb-template-control-ex-plans-due-at.component";
import { CbTemplateControlLanguage } from "../../../cb-template-control/components/cb-template-control-language/cb-template-control-language.component";
import { CbTemplateControlMarketingChannels } from "../../../cb-template-control/components/cb-template-control-marketing-channels/cb-template-control-marketing-channels.component";
import { CbTemplateControlNda } from "../../../cb-template-control/components/cb-template-control-nda/cb-template-control-nda.component";
import { CbTemplateControlRegions } from "../../../cb-template-control/components/cb-template-control-regions/cb-template-control-regions.component";
import { CbTemplateControlStatus } from "../../../cb-template-control/components/cb-template-control-status/cb-template-control-status.component";
import { CbTemplateControlVendorAssetsReq } from "../../../cb-template-control/components/cb-template-control-vendor-assets-req/cb-template-control-vendor-assets-req.component";
import { CbTemplateLayoutRight } from "../../../cb-template-layout/components/cb-template-layout-right/cb-template-layout-right.component";

export const CbTemplateStandardRightSection = (props: CbTemplateViewProps) => {
  const controlProps = createCbTemplateControlProps(props);

  return (
    <CbTemplateLayoutRight>
      <CbTemplateControlStatus {...controlProps} />
      <CbTemplateControlNda {...props.ndaData} {...controlProps} />
      <CbTemplateControlExPlansDueAt {...controlProps} />
      <CbTemplateControlLanguage {...controlProps} />
      <CbTemplateControlMarketingChannels
        isRequired={props.marketingChannelsIsRequired}
        {...controlProps}
      />
      <BorderedBlock>
        <CBSearchField
          form={props.form}
          label="Linked Campaign Briefs"
          name="linkedCampaignBriefs"
          userPermissions={props.userPermissions}
        />
      </BorderedBlock>
      <CbTemplateControlRegions {...controlProps} />
      <CbTemplateControlVendorAssetsReq {...controlProps} />
      <FileUploadWidget
        onDeleteFile={props.onDeleteFile}
        onUploadFile={props.onUploadFile}
        overviewAttachments={props.attachedFiles}
        icon={<AddIcon />}
      >
        Add Files
      </FileUploadWidget>
    </CbTemplateLayoutRight>
  );
};
